export default {
  "HitPaw Online Audio Converter": "HitPaw オンラインオーディオ変換",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "無料でオーディオをMP3、AAC、FLAC、WMAなどのフォーマットに変換します",
  'HitPaw Online Image Converter': 'HitPawオンライン画像コンバーター',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': '画像をJPG、PNG、BMP、TIFFなどの形式に無料で変換します',
  'HitPaw Online Video Converter': 'オンライン動画コンバーター',
  'Convert videos to any formats as your requirements.': '動画をお好きなフォーマットに変換します',
  'Add More Files': 'ファイルの追加',
  'Convert to': '変換先',
  'Ready': '準備完了',
  'Converting': '変換中',
  'Video': '動画',
  'Audio': 'オーディオ',
  'Image': 'イメージ',
  'Retry': 'やり直す',
  'Download All': '一括ダウンロード',
  'Download Desktop': 'デスクトップのダウンロード',
  'Continue Editing': '編集を続ける',
  'Convert': '変換',
  'Cut': 'カット',
  'Speed': 'スピード',
  'Crop & Rotate': 'クロップと回転',
  'Resize': 'サイズ変更',
  'Extract': '抽出',
  'Add Music': '音楽を追加',
  'Subtitles': 'サブタイトル',
  'Merge': '結合する',
  'Watermark Remover': 'ウォーターマーク除去',
  'Add Watermark': 'ウォーターマークを追加',
  'Please select a file to use': '{{work}}を使用するためにファイルを選択してください',
  'Batch Processing': 'Batch Processing',
};
